import { Component } from '@angular/core';
import { NgForm, NgSelectOption } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { AgencyService } from '../Services/Agency.service';
import { ParentUsers } from '../Models/ActiveClasses';
import { AddNewManagers, AgenciesForManagers } from '../Models/AgencyMasterProperties';
@Component({
  selector: 'app-managers',
  templateUrl: './managers.component.html',
  styleUrls: ['./managers.component.css']
})
export class ManagersComponent {
  managersSubmitted: boolean = false;
  loginAgency: string = "";
  managersList: ParentUsers[] = [];
  managerName: string = "";
  agencyList: AgenciesForManagers[] = [];
  addNewManager = new AddNewManagers();
  agencyhide: boolean = false;
  loaderVar: boolean = false;
  actionType: string = 'save';
  constructor(private agencyService: AgencyService) {

  }
  ngOnInit(): void {
    this.GetUsersForManager();
    this.GetAgencysList();
  }
  private GetUsersForManager = (): void => {
    this.loginAgency = localStorage.getItem("AgencyId")
    if (this.loginAgency != "" && this.loginAgency != undefined && this.loginAgency != null) {
      if (this.loginAgency == "AG01") {
        this.agencyService.GetUsersForManagers(this.loginAgency).subscribe(data => {
          this.managersList = data;
          let manager = new ParentUsers();
          manager.userId = 0;
          manager.labelName = "All";
          manager.fullname = "All";
          this.managersList.splice(0, 0, manager)
        })
      }
    }
  }
  private GetAgencysList = (): void => {
    this.loginAgency = localStorage.getItem("AgencyId");
    let userId: number = 0;
    this.agencyService.GetAgenciesForManagers(userId, this.loginAgency).subscribe(data => {
      this.agencyList = data;
      let agency = new AgenciesForManagers();
      agency.agencyId = "All";
      agency.agencyName = "All";
      this.agencyList.splice(0, 0, agency);
    });
  }
  public SelectManagers = (): void => {
    if (this.addNewManager.userId.includes(0)) {
      this.managersList = this.managersList.map(ids => ({
        ...ids,
        disabled: ids.userId !== 0,
      }));
      const filterIndex = this.addNewManager.userId.findIndex(id => id === 0);
      if (filterIndex !== -1) {
        this.addNewManager.userId.splice(0, this.addNewManager.userId.length, 0)
        this.addNewManager.managerName = [];
      }
      this.agencyhide = true;
    }
    else {
      this.managersList = this.managersList.map(ids => ({
        ...ids,
        disabled: false,
      }));
      if ((this.addNewManager.userId.length > 0 && this.addNewManager.userId.includes(0) == false)
        && this.addNewManager.agencyIds.length > 0 && this.addNewManager.agencyIds.includes("All") == false) {
        this.agencyhide = false;
      }
    }
  }
  public SelectedAgencies = (): void => {
    if (this.addNewManager.agencyIds.includes("All")) {
      this.agencyList = this.agencyList.map(agency => {
        return { ...agency, disabled: agency.agencyId !== "All" }
      });
      const filterIndex = this.addNewManager.agencyIds.findIndex(id => id === "All");
      if (filterIndex !== -1) {
        this.addNewManager.agencyIds.splice(0, this.addNewManager.agencyIds.length, "All")
      }
      this.agencyhide = true;
    }
    else {
      this.agencyList = this.agencyList.map(agency => {
        return { ...agency, disabled: false }
      });
      if ((this.addNewManager.userId.length > 0 && this.addNewManager.userId.includes(0) == false)
        && this.addNewManager.agencyIds.length > 0 && this.addNewManager.agencyIds.includes("All") == false) {
        this.agencyhide = false;
      }
    }
  }
  public SaveManagers = (managersForm: any, action: string): boolean => {
    this.managersSubmitted = true;
    //if (!managersForm.valid) {
    //  return false;
    //}
    // Only validate full form for SAVE

    if (!managersForm.valid) {
      return false;
    }
    else {
      document.getElementById("managers_submit").setAttribute('disabled', 'disabled');
      this.addNewManager.creationUser = Number(localStorage.getItem("UserId"));
      if (this.addNewManager.userId.includes(0)) {
        this.addNewManager.userId = [];
        this.addNewManager.managerName = [];
        for (let g = 0; g < this.managersList.length; g++) {
          if (this.managersList[g].userId != 0) {
            this.addNewManager.userId.push(this.managersList[g].userId);
            this.addNewManager.managerName.push(this.managersList[g].fullname);
          }
        }
        this.addNewManager.managerEmailAddress = null;
        this.addNewManager.managerPhone = null;
      }
      else {
        this.addNewManager.managerName = [];
        for (let j = 0; j < this.addNewManager.userId.length; j++) {
          this.managersList.forEach((user) => {
            if (user.userId == this.addNewManager.userId[j]) {
              this.addNewManager.managerName.push(user.fullname);
            }
          })
        }
      }
      if (this.addNewManager.agencyIds.includes("All")) {
        this.addNewManager.agencyIds = [];
        for (let g = 0; g < this.agencyList.length; g++) {
          if (this.agencyList[g].agencyId != "All") {
            this.addNewManager.agencyIds.push(this.agencyList[g].agencyId);
          }
        }
        this.addNewManager.managerEmailAddress = null;
        this.addNewManager.managerPhone = null;
      }
      this.loaderVar = true;

      if (action === 'save') {
        this.agencyService.AddNewManagers(this.addNewManager).subscribe(data => {
          if (data == true) {

            document.getElementById("managers_submit").removeAttribute('disabled');
            document.getElementById("managerSuccess").innerHTML = "Managers Created Successfully";
            setTimeout(() => {
              document.getElementById("managerSuccess").innerHTML = "";
            }, 5000)
            this.addNewManager = new AddNewManagers();
            this.managersSubmitted = false;
            this.loaderVar = false;
            this.agencyhide = false;
            this.SelectedAgencies();
            this.SelectManagers();
          }
          else {
            document.getElementById("managers_submit").removeAttribute('disabled');
            this.loaderVar = false;
            document.getElementById("managerError").innerHTML = "**Something Went Wrong!";
            setTimeout(() => {
              document.getElementById("managerError").innerHTML = "";
            }, 5000)
          }

        });
      }
      else if (action === 'remove') {

        this.agencyService.RemovingManagers(this.addNewManager).subscribe(data => {
          if (data == true) {

            document.getElementById("managers_submit").removeAttribute('disabled');
            document.getElementById("managerSuccess").innerHTML = "Managers removed Successfully";
            setTimeout(() => {
              document.getElementById("managerSuccess").innerHTML = "";
            }, 5000)
            this.addNewManager = new AddNewManagers();
            this.managersSubmitted = false;
            this.loaderVar = false;
            this.agencyhide = false;
            this.SelectedAgencies();
            this.SelectManagers();
          }
          else {
            document.getElementById("managers_submit").removeAttribute('disabled');
            this.loaderVar = false;
            document.getElementById("managerError").innerHTML = "**Something Went Wrong!";
            setTimeout(() => {
              document.getElementById("managerError").innerHTML = "";
            }, 5000)
          }

        });

      }

    }



  }
}
